import _ from "lodash";
import { FaClipboard, FaDev, FaFlask, FaFolderOpen, FaHardHat, FaMoneyBillWave, FaTags, FaTruckLoading, FaUsers } from "react-icons/fa";
import { RiListSettingsLine } from "react-icons/ri";
import { BsFillHouseDoorFill, BsUpcScan } from "react-icons/bs";
import { GiSewingString } from "react-icons/gi";
import { MdConstruction, MdInventory, MdSettings } from "react-icons/md";

const ICONS = {
  adminIcon: <RiListSettingsLine className="leftMenuButtons align-self-center" />,
  devIcon: <FaDev className="leftMenuButtons align-self-center" />,
  engineeringIcon: <MdConstruction className="leftMenuButtons align-self-center" />,
  homeIcon: <BsFillHouseDoorFill className="leftMenuButtons align-self-center" />,
  hrIcon: <FaFolderOpen className="leftMenuButtons align-self-center" />,
  inventoryIcon: <MdInventory className="leftMenuButtons align-self-center" />,
  maintenanceIcon: <FaHardHat className="leftMenuButtons align-self-center" />,
  partnerIcon: <FaUsers icon="user-tag" className="leftMenuButtons align-self-center" />,
  productionIcon: <FaClipboard className="leftMenuButtons align-self-center" />,
  purchasingIcon: <FaTags className="leftMenuButtons align-self-center" />,
  qualityIcon: <FaFlask className="leftMenuButtons align-self-center" />,
  salesIcon: <FaMoneyBillWave className="leftMenuButtons align-self-center" />,
  scanIcon: <BsUpcScan className="leftMenuButtons align-self-center" />,
  settingsIcon: <MdSettings className="leftMenuButtons align-self-center" />,
  sewingIcon: <GiSewingString className="leftMenuButtons align-self-center" />,
  warehouseIcon: <FaTruckLoading className="leftMenuButtons align-self-center"/>
};

const sidebarLinks = {
  resolveLinks(forMobile, menus) {
    if (!menus) {
      console.warn("No user found when resolving menus");
      return [];
    }
    // onMobile can arrive as null/undefined (device not yet classified, or a restored
    // session that never persisted it). The filter below compares with ===, so a null
    // would match no desktop menus and blank the entire sidebar. Absent device => desktop.
    forMobile = forMobile === true;
    const topLevelMenus = _.chain(menus)
      .filter(m => m.isMobile === forMobile && (m.isClickableParent || !m.parentMenuItemKey))
      .map(m => ({
        parent: { url: m.url, title: m.title }, 
        title: m.title,
        icon: m.iconKey ? ICONS[m.iconKey] : null,
        url: m.url,
        key: m.key,
        isClickableParent: m.isClickableParent
      }))
      .value();
      const result = _.map(topLevelMenus, t => ({
        ...t,
        dropdownMenu: t.isClickableParent
          ? null
          : _.chain(menus)
            .filter(sm => sm.parentMenuItemKey === t.key && sm.isMobile === forMobile)
            .map(sm => ({
              url: sm.url,
              title: sm.title
            }))
            .uniqBy("title")
            .value()
      }));
    return result
  }, 
  ICONS
};

export default sidebarLinks;